import api from '@/service/api';
import variables from "@/service/variables";
export default class Service {
    FormatDateTime(Date) {
        //2023-07-13T03:14:58
        let year = Date.getFullYear()
        let month = (Date.getMonth() + 1).toString().padStart(2, '0')
        let day = (Date.getDate()).toString().padStart(2, '0')
        let hour = (Date.getHours()).toString().padStart(2, '0')
        let minutes = (Date.getMinutes()).toString().padStart(2, '0')
        let seconds = (Date.getSeconds()).toString().padStart(2, '0')

        return year + '-' + month + '-' + day + 'T' + hour + ':' + minutes + ':' + seconds
    }

    GetBotURL() {
        return variables.API_URLBOTURL
    }
     PostImage(image) {
        return api.post(variables.API_URL +'/api/Photo/UploadImage', image)
    }
    //ApplyHeader
    GetApplyHeader(id) {
        return api.get(variables.API_URL +'/api/ApplyHeaders/GetApplyHeader_id/' + id)
    }
    GetApplyHeader_Create(AD, email) {
        return api.get(variables.API_URL +'/api/ApplyHeaders/GetApplyHeader_Create/' + AD + '/' + email)
    }
    GetApplyHeader_email(email) {
        return api.get(variables.API_URL +'/api/ApplyHeaders/GetApplyHeader_email/' + email)
    }
    PostApplyHeader(ApplyHeader) {
        return api.post(variables.API_URL +'/api/ApplyHeaders', ApplyHeader)
    }
    PutApplyHeader(id, ApplyHeader) {
        return api.put(variables.API_URL +'/api/ApplyHeaders/' + id, ApplyHeader)
    }

    //MFG
    GetMFG(id) {
        return api.get(variables.API_URL +'/api/ApplyMFGs/' + id)
    }
    PostApplyMFG(ApplyMFG) {
        return api.post(variables.API_URL +'/api/ApplyMFGs', ApplyMFG)
    }
    DeleteMFG(id) {
        return api.delete(variables.API_URL +'/api/ApplyMFGs/DeleteApplyMFG/' + id)
    }

    //Vendor
    GetVendor(id) {
        return api.get(variables.API_URL +'/api/ApplyVendorCodes/' + id)
    }
    GetVendorCode() {
        return api.get(variables.API_URL +'/api/ApplyVendorCodes')
    }
    GetVendorCode_MG() {
        return api.get(variables.API_URL +'/api/ApplyVendorCodes/VendorCode_MG')
    }
    PostApplyVendorCode(ApplyVendorCode) {
        return api.post(variables.API_URL +'/api/ApplyVendorCodes', ApplyVendorCode)
    }
    DeleteVendor(id) {
        return api.delete(variables.API_URL +'/api/ApplyVendorCodes/DeleteApplyVendorCode/' + id)
    }

    //MemberInfo
    GetEForm_MemberInfo(AD) {
        return api.get(variables.API_URL +'/api/EForm_MemberInfo/' + AD)
    }
    GetManager(AD) {
        return api.get(variables.API_URL +'/api/EForm_MemberInfo/Manager?AD=' + AD)
    }

    //Flow Header
    PostFlowHeader(FlowHeader) {
        return api.post(variables.API_URL +'/api/FlowHeaders', FlowHeader)
    }
    GetFlowHeaderAD(AD) {
        return api.get(variables.API_URL +'/api/FlowHeaders/FlowHeaderAD?AD=' + AD)
    }
    UpdateCurrentStep(id, currentstep, status) {
        return api.put(variables.API_URL +'/api/FlowHeaders/UpdateCurrentStep?id=' + id + '&CurrentStep=' + currentstep + '&Status=' + status)
    }
    //Flow Detail
    PostFlowDetail(FlowDetail) {
        return api.post(variables.API_URL +'/api/FlowDetails', FlowDetail)
    }
    UpdateFlowDetail(flowDetail) {
        return api.put(variables.API_URL +'/api/FlowDetails/UpdateFlowDetail', flowDetail)
    }
    GetFlowDetailID(ID) {
        return api.get(variables.API_URL +'/api/FlowDetails/FlowDetail_ID?ID=' + ID)
    }
    //VendorAccount
    PostVendorAccount(VendorAccount) {
        return api.post(variables.API_URL +'/api/VendorAccount', VendorAccount)
    }
    GetVendorAccount_Username(Username) {
        return api.get(variables.API_URL +'/api/VendorAccount/Username?username=' + Username)
    }
    GetVendorAccount_email(email) {
        return api.get(variables.API_URL + '/api/VendorAccount/email?email=' + email)
    }
    GetVendorSystem_SupID(id, system) {
        return api.get(variables.API_URL + '/api/VendorAccount/VendorSystem/' + id + '/' + system)
    }

    //VendorMFG
    PostVendorMFG(VendorMFG) {
        return api.post(variables.API_URL +'/api/VendorMFG', VendorMFG)
    }
    GetVendorMFG(id, BG, MFG) {
        return api.get(variables.API_URL +'/api/VendorMFG/' + id + '/' + BG + '/' + MFG)
    }
    GetVendorMFG_lst(id) {
        return api.get(variables.API_URL + '/api/VendorMFG/' + id )
    }

    //VendorMapping
    PostVendorMapping(VendorMapping) {
        return api.post(variables.API_URL +'/api/VendorMapping', VendorMapping)
    }
    GetVendorMapping(id, BG, Code) {
        return api.get(variables.API_URL +'/api/VendorMapping/' + id + '/' + BG + '/' + Code)
    }
    GetVendorMapping_lst(id) {
        return api.get(variables.API_URL + '/api/VendorMapping/' + id)
    }
    GetVendorMapping_All() {
        return api.get(variables.API_URL + '/api/VendorMapping/')
    }
    //SAPRFC
    GetVendorRFC(VendorType, lstVendor) {
        return api.get(variables.API_URL +'/api/SAPRFC/' + VendorType + '?' + lstVendor)
    }
    //VIPSystemBG
    GetVIPSystemBG(Name, BG) {
        return api.get(variables.API_URL +'/api/VIPSystemBGs/' + Name + '/' + BG)
    }
    PostVIPSystemBG(VIPSystemBG) {
        return api.post(variables.API_URL +'/api/VIPSystemBGs', VIPSystemBG)
    }
    GetVIPSystemBG_All(Name) {
        return api.get(variables.API_URL + '/api/VIPSystemBGs/' + Name)
    }
    UpdateVIPSystem_BG(SystemName, VIPSystem) {
        return api.put(variables.API_URL + '/api/VIPSystemBGs/' + SystemName, VIPSystem)
    }

   

    //VIPSystem
    PostVIPSystem(VIPSystem) {
        return api.post(variables.API_URL +'/api/VIPSystem', VIPSystem)
    }
    GetVIPSystem() {
        return api.get(variables.API_URL +'/api/VIPSystem/GetVIPSystem_All')
    }
    UpdateVIPSystem(SystemName, VIPSystem) {
        return api.put(variables.API_URL + '/api/VIPSystem/' + SystemName, VIPSystem)
    }

    //ApplySystem
    PostApplySystem(ApplySystem) {
        return api.post(variables.API_URL +'/api/ApplySystems', ApplySystem)
    }
    DeleteApplySystem(id) {
        return api.delete(variables.API_URL +'/api/ApplySystems/' + id)
    }
    GetApplySystem(id) {
        return api.get(variables.API_URL +'/api/ApplySystems/' + id)
    }
    PostVendorAccountBG(VendorAccountBG) {
        return api.post(variables.API_URL +'/api/VendorAccountBG', VendorAccountBG)
    }
    GetVendorAccountBG(id, BG) {
        return api.get(variables.API_URL +'/api/VendorAccountBG/' + id + '/' + BG)
    }
    GetVendorAccountBG_id(id) {
        return api.get(variables.API_URL + '/api/VendorAccountBG/' + id)
    }

    PostApplyAttachment(ApplyAttachment) {
        return api.post(variables.API_URL +'/api/ApplyAttachment', ApplyAttachment)
    }
    GetApplyAttachment(id) {
        return api.get(variables.API_URL +'/api/ApplyAttachment/' + id)
    }
    GetVendorSystem(id, VIPSystem) {
        return api.get(variables.API_URL +'/api/VendorSystem/' + id + '/' + VIPSystem)
    }
    GetVendorSystem_id(id) {
        return api.get(variables.API_URL +'/api/VendorSystem/' + id)
    }
    PostVendorSystem(VendorSystem) {
        return api.post(variables.API_URL +'/api/VendorSystem', VendorSystem)
    }
    DeleteVendorSystem(id, VIPSystem) {
        return api.delete(variables.API_URL + '/api/VendorSystem/' + id + '/' + VIPSystem)
    }

    //BusinessType
    GetBusinessType() {
        return api.get(variables.API_URL +'/api/BusinessType')
    }
    GetUserInfo(){
        return api.get(variables.API_URL +'/api/Account/GetUserInfo')
    }


    //Flow Detail
    PostBulletin(flowDetail) {
        return api.post(variables.API_URL +'/api/Bulletin', flowDetail)
    }
    UpdateBulletin(flowDetail) {
        return api.put(variables.API_URL +'/api/Bulletin', flowDetail)
    }
    DeleteBulletin(ID) {
        return api.delete(variables.API_URL +'/api/Bulletin/' + ID)
    }
    GetBulletin(ID) {
        return api.get(variables.API_URL +'/api/Bulletin/' + ID)
    }
    GetBulletins() {
        return api.get(variables.API_URL +'/api/Bulletin');
    }
    
    //parts
    GetApplyHeader_email_parts(email) {
        return api.get(variables.API_URL + '/api/Parts/GetApplyHeader_email/' + email)
    }
    GetVendorCode_parts() {
        return api.get(variables.API_URL + '/api/Parts/ApplyVendorCode')
    }
    GetVendorCode_MG_parts() {
        return api.get(variables.API_URL + '/api/Parts/VendorCode_MG')
    }
    GetEForm_MemberInfo_parts(AD, BG) {
        return api.get(variables.API_URL + '/api/Parts/EForm_MemberInfo/' + AD + '/' + BG)
    }
    GetVIPSystem_parts() {
        return api.get(variables.API_URL + '/api/Parts/GetVIPSystem_All')
    }
    GetBusinessType_parts() {
        return api.get(variables.API_URL + '/api/Parts/BusinessType')
    }
    GetVendorAccount_email_parts(email) {
        return api.get(variables.API_URL + '/api/Parts/email?email=' + email)
    }
    GetVendorAccountBG_id_parts(id) {
        return api.get(variables.API_URL + '/api/Parts/VendorAccountBG/' + id)
    }


    //sourcerCreateSupervisor
    CreateSupervisor(CreateSupervisor) {
        return api.post(variables.API_URL + '/api/sourcerCreateSupervisor', CreateSupervisor);
    }
    DraftToSend(CreateSupervisor) {
        return api.post(variables.API_URL + '/api/sourcerCreateSupervisor/DraftToSend', CreateSupervisor);
    }
    GetApplyHeader_scs(id) {
        return api.get(variables.API_URL + '/api/sourcerCreateSupervisor/GetApplyHeader_id/' + id)
    }
    GetApplyHeader_email_scs(email) {
        return api.get(variables.API_URL + '/api/sourcerCreateSupervisor/GetApplyHeader_email/' + email)
    }
    GetManager_scs(AD) {
        return api.get(variables.API_URL + '/api/sourcerCreateSupervisor/Manager?AD=' + AD)
    }



    //vendorUserCreate
    VendorUserCreateGet(userid) {
        return api.get(variables.API_URL + '/api/VendorUserCreate?UserID=' + userid)
    }
    VendorUserCreatePost(vendorUserCreate) {
        return api.post(variables.API_URL + '/api/VendorUserCreate', vendorUserCreate)
    }
    GetApplyHeader_vuc(id) {
        return api.get(variables.API_URL + '/api/VendorUserCreate/GetApplyHeader_id/' + id)
    }
    GetApplyHeader_email_vuc(email) {
        return api.get(variables.API_URL + '/api/VendorUserCreate/GetApplyHeader_email/' + email)
    }
    GetManager_vuc(AD) {
        return api.get(variables.API_URL + '/api/VendorUserCreate/Manager?AD=' + AD)
    }
    GetVendorAccount_email_vuc(email) {
        return api.get(variables.API_URL + '/api/VendorUserCreate/email?email=' + email)
    }
    GetVendorMFG_vuc(id, BG, MFG) {
        return api.get(variables.API_URL + '/api/VendorUserCreate/VendorMFG/' + id + '/' + BG + '/' + MFG)
    }
    GetVendorMapping_vuc(id, BG, Code) {
        return api.get(variables.API_URL + '/api/VendorUserCreate/VendorMapping/' + id + '/' + BG + '/' + Code)
    }
    GetVendorAccountBG_vuc(id, BG) {
        return api.get(variables.API_URL + '/api/VendorUserCreate/VendorAccountBG/' + id + '/' + BG)
    }
    GetVendorSystem_vuc(id, VIPSystem) {
        return api.get(variables.API_URL + '/api/VendorUserCreate/VendorSystem/' + id + '/' + VIPSystem)
    }


    //SupAssignVendorMFGtoUser
    SupAssignVendorMFGtoUserGet(userid, createUser) {
        return api.get(variables.API_URL + '/api/SupAssignVendorMFGtoUser?UserID=' + userid + '&&CreateUser=' + createUser)
    }
    SupAssignVendorMFGtoUserPost(supAssignVendorMFGtoUserPost) {
        return api.post(variables.API_URL + '/api/SupAssignVendorMFGtoUser', supAssignVendorMFGtoUserPost)
    }
    GetManager_sau(AD) {
        return api.get(variables.API_URL + '/api/SupAssignVendorMFGtoUser/Manager?AD=' + AD)
    }
    GetVendorAccountBG_id_sau(id) {
        return api.get(variables.API_URL + '/api/SupAssignVendorMFGtoUser/VendorAccountBG/' + id)
    }


    //FlowApproval
    FlowApprovalGet(FlowID, bg) {
        return api.get(variables.API_URL + '/api/FlowApproval?FlowID=' + FlowID + '&&BG=' + bg)
    }
    FlowApprovalPost(ApprovalPost, type) {
        return api.post(variables.API_URL + '/api/FlowApproval/' + type, ApprovalPost)
    }
    FlowApproval_type6Post(Supervisor_old, Supervisor_new, UserName_new, BG, CreateUser) {
        return api.post(variables.API_URL + '/api/FlowApproval?Supervisor_old=' + Supervisor_old
            + '&&Supervisor_new=' + Supervisor_new + '&&UserName_new=' + UserName_new + '&&BG=' + BG + '&&CreateUser=' + CreateUser)
    }
    GetVendorAccount_email_fa(email) {
        return api.get(variables.API_URL + '/api/FlowApproval/email?email=' + email)
    }
    GetVendorMFG_fa(id, BG, MFG) {
        return api.get(variables.API_URL + '/api/FlowApproval/VendorMFG/' + id + '/' + BG + '/' + MFG)
    }
    GetVendorMapping_fa(id, BG, Code) {
        return api.get(variables.API_URL + '/api/FlowApproval/VendorMapping/' + id + '/' + BG + '/' + Code)
    }
    GetVendorAccountBG_fa(id, BG) {
        return api.get(variables.API_URL + '/api/FlowApproval/VendorAccountBG/' + id + '/' + BG)
    }
    GetVendorSystem_fa(id, VIPSystem) {
        return api.get(variables.API_URL + '/api/FlowApproval/VendorSystem/' + id + '/' + VIPSystem)
    }


    //SupervisorAccountTransfer
    SupervisorAccountTransferGet(email, BG) {
        return api.get(variables.API_URL + '/api/SupervisorAccountTransfer?email=' + email + '&&BG=' + BG)
    }
    SupervisorAccountTransferPost(SupervisorAccountTransfer) {
        return api.post(variables.API_URL + '/api/SupervisorAccountTransfer', SupervisorAccountTransfer)
    }
    SupervisorAccountTransferPost_SUP(Supervisor_old, Supervisor_new, UserName_new, CreateUser) {
        return api.post(variables.API_URL + '/api/SupervisorAccountTransfer/sup?Supervisor_old=' + Supervisor_old
            + '&&Supervisor_new=' + Supervisor_new + '&&UserName_new=' + UserName_new + '&&CreateUser=' + CreateUser)
    }
    GetVendorAccount_supID(email, supID) {
        return api.get(variables.API_URL + '/api/SupervisorAccountTransfer/account?email=' + email + '&&userid=' + supID)
    }
    GetVendorAccount_sou(sourcer) {
        return api.get(variables.API_URL + '/api/SupervisorAccountTransfer/supid?sourcer=' + sourcer)
    }
    GetManager_sat(AD) {
        return api.get(variables.API_URL + '/api/SupervisorAccountTransfer/Manager?AD=' + AD)
    }
    GetAccountList(AD) {
        return api.get(variables.API_URL + '/api/SupervisorAccountTransfer/AccountList?Sourcer=' + AD)
    }

    
    
    GetVIPSystem_Page() {
        return api.get(variables.API_URL + '/api/NewSystemRelease/GetVIPSystem_All')
    }

    
    GetApplyHeader_ap(id) {
        return api.get(variables.API_URL + '/api/ApprovalPage/GetApplyHeader_id/' + id)
    }
    GetVendorAccount_email_ap(email) {
        return api.get(variables.API_URL + '/api/ApprovalPage/email?email=' + email)
    }
    GetVendorAccountBG_ap(id, BG) {
        return api.get(variables.API_URL + '/api/ApprovalPage/' + id + '/' + BG)
    }
    GetVendorMFG_lst_ap(id) {
        return api.get(variables.API_URL + '/api/ApprovalPage/GetVendorMFG/' + id)
    }
    GetVendorMapping_lst_ap(id) {
        return api.get(variables.API_URL + '/api/ApprovalPage/GetVendorMapping/' + id)
    }
    GetMFG_ap(id) {
        return api.get(variables.API_URL + '/api/ApprovalPage/ApplyMFG/' + id)
    }
    GetVendor_ap(id) {
        return api.get(variables.API_URL + '/api/ApprovalPage/ApplyVendorCode/' + id)
    }

    //ApplyPage
    GetMFG_applyp(id) {
        return api.get(variables.API_URL + '/api/ApplyPage/ApplyMFG/' + id)
    }
    GetVendor_applyp(id) {
        return api.get(variables.API_URL + '/api/ApplyPage/ApplyVendorCode/' + id)
    }
    GetApplySystem_applyp(id) {
        return api.get(variables.API_URL + '/api/ApplyPage/ApplySystem/' + id)
    }
    
    //VendorApplySystem
    GetVendorApplySystem(userId) {
        return api.get(variables.API_URL + '/api/VendorApplySystem?UserID=' + userId)
    }
    
    GetVendorAccount_email_vas(email) {
        return api.get(variables.API_URL + '/api/VendorApplySystem/email?email=' + email)
    }
    VendorApplySystemPost(vendorUserCreate) {
        return api.post(variables.API_URL + '/api/VendorApplySystem/all', vendorUserCreate)
    }
    
    GetManager_vas(AD) {
        return api.get(variables.API_URL + '/api/VendorApplySystem/Manager?AD=' + AD)
    }
    GetVendorSystem_vas(id, VIPSystem) {
        return api.get(variables.API_URL + '/api/VendorApplySystem/' + id + '/' + VIPSystem)
    }
    
    //ApplyVendorMFGCode
    GetVendorAccount_email_avc(email) {
        return api.get(variables.API_URL + '/api/ApplyVendorMFGCode/email?email=' + email)
    }
    GetVendorAccountBG_id_avc(id) {
        return api.get(variables.API_URL + '/api/ApplyVendorMFGCode/VendorAccountBG/' + id)
    }
    GetVendorMapping_lst_avc(id) {
        return api.get(variables.API_URL + '/api/ApplyVendorMFGCode/VendorMapping/' + id)
    }
    GetVendorMFG_lst_avc(id) {
        return api.get(variables.API_URL + '/api/ApplyVendorMFGCode/VendorMFG/' + id)
    }
    GetVendorMapping_All_avc() {
        return api.get(variables.API_URL + '/api/ApplyVendorMFGCode/VendorMappingAll/')
    }
    GetVendorCode_avc() {
        return api.get(variables.API_URL + '/api/ApplyVendorMFGCode/ApplyVendorCodeAll')
    }
    ApplyVendorMFGCodePost(ApplyVendorMFGCode) {
        return api.post(variables.API_URL + '/api/ApplyVendorMFGCode', ApplyVendorMFGCode)
    }
    GetManager_avc(AD) {
        return api.get(variables.API_URL + '/api/ApplyVendorMFGCode/Manager?AD=' + AD)
    }

    //SupervisorUserQuery
    GetVendorAccount_Sourcer(Sourcer) {
        return api.get(variables.API_URL + '/api/SupervisorUserQuery/Sourcer?Sourcer=' + Sourcer)
    }
    GetVendorAccount_SCSI() {
        return api.get(variables.API_URL + '/api/SupervisorUserQuery/SCSI')
    }
    //ChangeContactSourcer
    ChangeContactSourcerGet(Sourcer, BG) {
        return api.get(variables.API_URL + '/api/ChangeContactSourcer?Sourcer=' + Sourcer + '&&BG=' + BG)
    }
    ChangeContactSourcerPost(email, sourcerbefore, sourcerafter, USERaccount, BG) {
        return api.post(variables.API_URL + '/api/ChangeContactSourcer?sourcerbefore='
            + sourcerbefore + '&&sourcerafter=' + sourcerafter + '&&USERaccount=' + USERaccount+ '&&BG=' + BG, email)
    }
    //AccountReview
    GetAccountReview(userid) {
        return api.get(variables.API_URL + '/api/AccountReview?userid=' + userid)
    }
    AccountReviewPost(email) {
        return api.post(variables.API_URL + '/api/AccountReview', email)
    }
}